import { render } from "./projects.vue?vue&type=template&id=6ac2d0fb&scoped=true"
import script from "./projects.vue?vue&type=script&lang=js"
export * from "./projects.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-6ac2d0fb"

export default script